<template>
    <div
        v-else
        @click="vote"
        class="vote"
        :class="{
            'vote-active': active,
            'vote-up': up,
            'vote-down': !up,
            'loader': loader
        }"
    ></div>
</template>

<script>
    export default {
        name: 'StoryVote',
        props: {
            id: {
                type: Number,
                required: true
            },
            up: {
                type: Boolean,
                required: true
            },
            active: {
                type: Boolean,
                required: true
            },
            feed: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                loader: false
            }
        },
        methods: {
            vote() {
                this.loader = true;
                let url = this.up ? '/like/' : '/dislike/'
                this.$store.dispatch((this.feed ? 'home' : 'stories') + '/vote', {id: this.id, url: url, type: 'stories'})
                .then(() => {
                    this.loader = false;
                })
                .catch(() => {
                    this.loader = false;
                });
            }
        }
    }
</script>
